import $ from 'jquery'

/**
 * @module
 * @api
 */

/**
 * Identify
 *
 * @param {string} position
 * @constructor
 */
export default function Identify(config) {
  $.extend(this, config || {})
  this.customPopupHandler = undefined
  this.handlers = []
}

/**
 * Get all handlers
 * @return {Identify~requestCallback[]}
 * @memberof! module:api/Identify#
 */
Identify.prototype.getHandlers = function() {
  return this.handlers
}

/**
 * Add event listener
 * @param {string} type event type. Supported types is "response".
 * @param {Identify~requestCallback} cb - The callback that handles the response.
 * @memberof! module:api/Identify#
 * @api
 */
Identify.prototype.on = function(type, callback) {
  this.handlers.push({
    type: type,
    callback: callback
  })
}

/**
 * This callback is displayed as part of the Indentify class.
 * @memberof! module:api/Identify#
 * @callback Identify~requestCallback
 * @param {FeatureCollection[]} responses
 * @param {Object} layer Layer config
 * @param {Object} click Click event metadata
 * @api
 */

/**
 * Remove event listener
 * @param {string} type event type
 * @param {Identify~requestCallback} cb - The callback to remove
 * @memberof! module:api/Identify#
 * @api
 */
Identify.prototype.un = function(type, callback) {
  this.handlers = this.handlers.filter(
    handler => handler.type !== type || handler.callback !== callback
  )
}

/**
 * Custom popup handler
 *
 * function(features,selectFeature) => HTMLElement | null | undefined
 *
 * features - Recieves a FeatureColletion[] of found features at coordinate where click occured
 * selectFeature - Function to call for selecting a specific feature in the map ( often used in conjunction with the featureCollection recieved)
 *
 *
 * Return a custom HTMLElement or null/undefined - null/undefined is considered handled and will not show any popup in canvas
 * setCustomPopupHandler(undefined) to remove handler
 * @memberof! module:api/Identify#
 * @api
 */
Identify.prototype.setCustomPopupHandler = function(popupHandler) {
  this.customPopupHandler = popupHandler
}
